import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { LoungesEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-lounge-loading-screen',
  templateUrl: './lounge-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class LoungesLoadingScreenComponent extends ProductLoadingScreen<LoungesEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Lounge]);
  }
}
